var map = {
	"./birds.JPG": 8414,
	"./busy_city.JPG": 6978,
	"./calm_waves.JPG": 6535,
	"./city_park.JPG": 8881,
	"./city_rain.JPG": 253,
	"./duck_pond.JPG": 2137,
	"./fire.JPG": 458,
	"./mexico_market.JPG": 2660,
	"./mic_drawing.png": 8665,
	"./river.JPG": 4368,
	"./sea.JPG": 335
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6303;